module.exports = __webpack_public_path__ + "img/sv46.82511bc5.svg";